export default __webpack_public_path__ + "static/media/question-mark-icon.7e867051.svg";